import { AMENITY_ROOM_TYPE } from "../../../../../configs/Constants";

export const INITIAL_STATUSES = [0, 1];
export const SEARCH_DEBOUNCE_DELAY = 500;

export const AMENITY_LIST_FILTER = {
  page: 1,
  item_per_page: 100,
  types: [AMENITY_ROOM_TYPE],
};
